import { translateFn } from '../../utils/translator.helper';
import {
  Actions,
  ActionsColumnValues,
  AffectedDeviceType,
  ChangeStateBulkValues,
  ChangeWatchlistBulkValues,
  Compliance,
  FindingsDetailsItemsType,
  InlineMenuExtraDetailsSelectEvents,
  MitigationType,
  ScoreLevels,
  State,
  Status,
  Watchlist,
  CloudProviders,
  DEVICES_TYPE,
  AllCloudProviders,
  DEVICES_TYPES_ORDER,
  DEVICES_CLASS,
  DropdownActionsSelection,
  MisconfigurationType,
} from './constants';
import { API_TYPE_RISK_MANAGEMENT, WEB_COMPONENT_GZ_IMAGE_REPO } from '../../webcomponents.constants';
import { GetItemsResponse } from '../../ui/gzSingleSelectComplex/types';
import {
  CompanyFilterDashboardDataProvider,
} from '../../ui/gzSingleSelectComplex/dataProvider/company/CompanyFilterDashboardDataProvider';
import { ColumnIndexes, ColumnKeys, USERS_ICON_CLASS_MAP, USERS_TYPES_ORDER } from '../userBehaviorRisksApp/types';
import _ from 'lodash';
import { GridTitleConfig } from '../../grid/uiElements/gridViewTitle/types';
import { configureFavoriteIcon } from '../../grid/genericGridSmartViews/types';
import { defaultPageSizeOptions, SelectionStoreMode } from '../../grid/gridView/types';
import { GzSingleSelectComplexWebComponent } from '../../ui/gzSingleSelectComplex';
import { GzImageRepoWebComponent } from '../../ui/gzImageRepo';
import { dataGridStrings } from '../../grid/utils/gridStrings';
import { ImageState } from '../../ui/gzImageRepo/types';
import { GridViewWebComponent } from '../../grid/gridView';
import { BaseWebComponentTranslator } from '../../framework/BaseWebComponentTranslator';
import { OperatingSystemType } from '@nirvana/shared/dtos/types/protected-entities/common';
import { GzToast, ToastSeverity } from '../../ui/gzToastNotification/type';
import { GzToastNotificationWebComponent } from '../../ui/gzToastNotification';
import { ConsoleRequest, DataProviderType } from '../../utils/request';
import { GzSideMenuWebComponent } from '../../ui/gzSideMenu';
import {
  createActionDialog,
  renderDialogText,
  renderRiskScanOptions,
  RiskManagementSideMenuEvents,
} from '../sideMenus/common/common';
import { GzLinkWebComponent } from '../../ui/gzLinkComponent';
import {
  copyToClipboard,
  ElementClass,
  elementClassListAdd,
  elementClassListRemove,
} from '../../utils/htmlElement.utils';
import { ButtonTypes } from '../../ui/gzButton/types';
import { DeviceExtraDetailsWebComponent } from '../sideMenus/components/deviceExtraDetails';
import { UserExtraDetailsWebComponent } from '../sideMenus/components/userExtraDetails';
import { FilterChangeEvents } from '../../grid/gridFilters/types';
import { GzTooltip } from '../../ui/gzTooltip';
import { GzButtonWebComponent } from '../../ui/gzButton';
import { ActionsDetails, CategoriesItems } from '../../sideMenus/categoriesSideMenu/types';
import { CategoriesSideMenuWebComponent } from '../../sideMenus/categoriesSideMenu';
import { ColumnKeys as DevicesColumnKeys } from '../devicesApp/types';
import { NavigationHelper } from '@nirvana/shared/navigation';
import { Feature } from '@nirvana/shared/constants';

interface RiskScanParams {
  parameters: {
    companyId: string;
    actionType: Actions.SCAN;
    scanEndpoints: boolean;
    scanCloud: boolean;
    scanNSVA: boolean;
  };
}

export function getStatusColumnValues() {
  const values = [Status.COMPLIANT, Status.DETECTED];
  return values.map(value => {
    return {
      label: BaseWebComponentTranslator.getInstance().getRiskManagementStatus(value),
      value,
    };
  });
}

export function getStateColumnValues() {
  const values = [State.ACTIVE, State.IGNORED];
  return values.map(value => {
    return {
      label: BaseWebComponentTranslator.getInstance().getRiskManagementState(value),
      value,
    };
  });
}

export function getWatchlistColumnValues() {
  const values = [Watchlist.YES, Watchlist.NO];
  return values.map(value => {
    return {
      label: BaseWebComponentTranslator.getInstance().getRiskManagementWatchlist(value),
      value,
    };
  });
}

export function getComplianceColumnValues() {
  const values = [
    Compliance.NONE,
    Compliance.CISv8,
    Compliance.SOC2,
    Compliance.ISO27001,
    Compliance.GDPR,
    Compliance.NIS2,
    Compliance.DORA,
    Compliance.BDCHBWINDOWS,
    Compliance.CMMC2,
    Compliance.PCIDSSV4,
    Compliance.HIPAA,
  ];

  return values.map(value => {
    return {
      label: BaseWebComponentTranslator.getInstance().getRiskManagementCompliance(value),
      value,
    };
  });
}

export function getMitigationTypeColumnValues() {
  const values = [MitigationType.MANUAL, MitigationType.AUTOMATIC];

  return values.map(value => {
    return {
      label: BaseWebComponentTranslator.getInstance().getRiskManagementMitigationType(value),
      value,
    };
  });
}

export function getOSTypeColumnValues(hasCloudResources = true) {
  const values: number[] = [
    OperatingSystemType.UNKNOWN,
    // Add those back when we have support for the platforms
    // OperatingSystemType.IOS,
    // OperatingSystemType.ANDROID,
    OperatingSystemType.WINDOWS,
    OperatingSystemType.LINUX,
    OperatingSystemType.MACOSX,
    // OperatingSystemType.CONTAINER,
  ];

  if (hasCloudResources) {
    values.push(...[CloudProviders.AWS, CloudProviders.GCP, CloudProviders.AZURE]);
  }

  // Add Kubernetes to the list of OS types
  if (Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_KSPM_USABLE])) {
    values.push(AffectedDeviceType.K8S_NAMESPACE);
  }

  return values.map(value => {
    return {
      label: BaseWebComponentTranslator.getInstance().getOperatingSystem(value),
      value,
    };
  });
}

export function getCompanyFilterUiConfig(columnKey) {
  return {
    key: columnKey,
    config: {
      apiType: API_TYPE_RISK_MANAGEMENT,
      populateFilterCallback(filterComponent, value) {
        const company = value.exactMatch;
        if (company) {
          const selectedValues: GetItemsResponse = {
            items: [],
            totalItemsCount: 0,
          };
          CompanyFilterDashboardDataProvider.getCompanyNameById(company).then(companyName => {
            selectedValues.items.push({
              label: companyName,
              value: company,
            });
            selectedValues.totalItemsCount = 1;
            filterComponent.setFilterOptions(selectedValues).then(() => {
              filterComponent.value = value.exactMatch;
              const event = new CustomEvent(FilterChangeEvents.REMOTE_SELECT_CHANGED, {
                detail: {
                  selectedValue: company,
                  label: companyName,
                },
                bubbles: true,
                composed: true,
              });
              filterComponent.dispatchEvent(event);
            });
          });
        }
      },
    },
  };
}

export function cleanUpEnumFilter(filter, valuesToCleanup, remainingValues) {
  for (const os of valuesToCleanup) {
    const index = filter['in'].indexOf(os);
    if (index > -1) {
      filter['in'].splice(index, 1);
    }
  }

  if (filter['in'].length === 0) {
    filter['in'] = remainingValues;
  }
}

export function setGridCommonProperties(
  grid: any,
  view: any,
  hasExternalFilters: boolean = false,
  initialViewWithoutExternalFilters: null | any = null,
) {
  if (Application.Main.company.isCustomer()) {
    cleanupSmartView(view);
    if (initialViewWithoutExternalFilters) {
      cleanupSmartView(initialViewWithoutExternalFilters);
    }
  }

  grid.hasFilters = true;
  grid.enableRowClickEvent = true;

  if (hasExternalFilters && initialViewWithoutExternalFilters) {
    grid.defaultViewProps = _.cloneDeep(initialViewWithoutExternalFilters);
    grid.titleConfig = new GridTitleConfig(view.label + '*');
    grid.activeViewInitialProps = _.cloneDeep(initialViewWithoutExternalFilters);
    grid.smartViewDiscardButtonDisabledState = false;
  } else {
    grid.defaultViewProps = _.cloneDeep(view);
    grid.titleConfig = new GridTitleConfig(view.label);
    grid.activeViewInitialProps = _.cloneDeep(view);
    grid.smartViewDiscardButtonDisabledState = true;
  }

  grid.viewId = view.id;
  grid.columns = view.displayedColumns;

  grid.filters = view.filters;
  grid.isCompactViewChecked = view.compactView;
  grid.pageSize = view.pageSize;
  //column configs should be reset here otherwise they will not be overwritten
  grid.columnConfigs = [];
  grid.columnConfigs = view.columnConfigs ?? [];
  grid.favoriteIconConfig = configureFavoriteIcon(view);
  grid.hasSelectableRows = true;
  grid.hasPagination = true;
  grid.pageSizeOptions = defaultPageSizeOptions;
  grid.sortColumnName = ColumnKeys.RISK_SCORE;
  grid.sortDirection = 'DESC';
  grid.customStrings = {
    noSearchResultsString: translateFn('Start scan to find risks'),
    dataLoadingFailed: dataGridStrings().dataLoadingFailed,
  };
  grid.onDataLoadingFinishedWithError = (error: { exceptionType: string }) => {
    if (error.exceptionType === 'DAL\\Exceptions\\SecurityException') {
      grid.customStrings = {
        noSearchResultsString: translateFn('Start scan to find risks'),
        dataLoadingFailed: translateFn("You do not have permission to view the company's data."),
      };
      grid.controller.updateCustomStrings();
    }
  };

  grid.selectionStoreConfig = {
    functionalMode: SelectionStoreMode.RECORDS,
  };
  grid.enableCSVExport = true;
  grid.smartViewsEnabled = true;
  grid.activeViewProps = view;
}

export function cleanupSmartView(view) {
  view.displayedColumns = view.displayedColumns.filter((column: ColumnIndexes) => column !== ColumnIndexes.COMPANY);
  view.filters = view.filters.filter(filter => !filter['companyId']);
}

export function processExternalFilters(view, externalFilters) {
  const currentViewFilters: any = _.cloneDeep(view.filters);
  let hasExternalFilters = false;
  let initialViewWithoutExternalFilters;
  if (externalFilters.length > 0) {
    hasExternalFilters = true;
    initialViewWithoutExternalFilters = _.cloneDeep(view);

    for (const externalFilter of externalFilters) {
      const filterName = Object.keys(externalFilter)[0];

      const filterIndex = currentViewFilters.findIndex(elem => {
        return Object.keys(elem).includes(filterName);
      });

      if (filterIndex === -1) {
        currentViewFilters.push(externalFilter);
      } else {
        currentViewFilters[filterIndex] = externalFilter;
      }
    }

    view.filters = [...currentViewFilters];
  }

  return {
    view,
    hasExternalFilters,
    initialViewWithoutExternalFilters,
  };
}

export function getCompanyExtraFilterForComplexEnumFilterCallback(componentName): Array<any> {
  const companyFilterComponent = document
    .querySelector(componentName)
    ?.shadowRoot?.querySelector('gz-grid-view')
    ?.shadowRoot?.querySelector('gz-grid-filters')
    ?.shadowRoot?.querySelector('gz-single-select-complex') as GzSingleSelectComplexWebComponent;

  if (!companyFilterComponent) {
    return [];
  }

  const companyFilterValue = companyFilterComponent.value;

  if (!companyFilterValue) {
    return [];
  }

  return [
    {
      property: 'companyId[exactMatch]',
      value: companyFilterValue,
    },
  ];
}

export function getAffectedDeviceTypeColumnValues() {
  const allValues = Object.values(DEVICES_TYPE).map(value => {
    return {
      label: BaseWebComponentTranslator.getInstance().getDeviceTypes(value),
      value,
    };
  });

  return [
    {
      label: translateFn('Not affected'),
      value: AffectedDeviceType.NOT_AFFECTED,
    },
    ...allValues,
  ];
}

export function changeEmptyStateIcon(grid: GridViewWebComponent<any, any>) {
  const imageRepoComponent = grid.shadowRoot?.querySelector(WEB_COMPONENT_GZ_IMAGE_REPO) as GzImageRepoWebComponent;
  if (!imageRepoComponent) {
    return;
  }
  const slot = grid.shadowRoot?.querySelector('slot[name=no-results--additional-data]') as any;
  if (slot.assignedElements()[0]) {
    slot.assignedElements()[0].hidden = false;
  }

  if (imageRepoComponent.state === ImageState.EMPTY) {
    imageRepoComponent.setAttribute('state', ImageState.START);
  }
}

export function handleComplexEnumFilter(complexEnumFilterColumns, filters) {
  const filtersToRemove: Array<string> = [];
  for (const filter of filters) {
    if (complexEnumFilterColumns.includes(filter['property']) && filter['value']) {
      if (filter['value'].length === 0) {
        filtersToRemove.push(filter['property']);
      } else {
        filter['value'] = filter['value'].map(item => {
          return item.value;
        });
      }
    }
  }

  return filters.filter(filter => !filtersToRemove.includes(filter['property']));
}

export function getBulletColorForScore(score: number) {
  switch (true) {
    case score >= ScoreLevels.HIGH:
      return 'var(--red-alert-500-severe)';
    case score >= ScoreLevels.MEDIUM && score < ScoreLevels.HIGH:
      return 'var(--orange-alert-chart-100)';
    case score >= ScoreLevels.LOW && score < ScoreLevels.MEDIUM:
      return 'var(--yellow-alert-050)';
    default:
      return 'var(--green-pastel-alert-chart-050-healty)';
  }
}

export function formatMacAddress(macAddress: string): string {
  const upperMac = macAddress.toUpperCase();

  const pairs: Array<string> = [];
  for (let i = 0; i < upperMac.length; i += 2) {
    pairs.push(upperMac.slice(i, i + 2));
  }

  return pairs.join('-');
}

export async function updateWatchlist(
  data,
  gridComponent: GridViewWebComponent<any, any>,
  sideMenu: GzSideMenuWebComponent,
  sideMenuComponentName: string,
  backendModelName: string,
) {
  if (!gridComponent.controller) {
    return;
  }

  let toastSuccessMessage = translateFn('Successfully added to watchlist.');
  let toastFailMessage = translateFn('Failed to add to watchlist.');

  if (data.newWatchlist === Watchlist.NO) {
    toastSuccessMessage = translateFn('Successfully removed from watchlist.');
    toastFailMessage = translateFn('Failed to remove from watchlist.');
  }

  const specificSideMenu = sideMenu.querySelector(sideMenuComponentName) as any;

  // Setting loading back to false will be handled by catch block or `handleGridItemsLoad` at the end
  gridComponent.controller.setLoadingState(true);

  try {
    const response = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: backendModelName,
      method: 'changeWatchlist',
      payload: {
        ids: data.ids,
        newWatchlist: data.newWatchlist,
        companyId: data.companyId,
      },
    });
    GzToastNotificationWebComponent.closeAllToasts();
    showWatchlistActionToast(toastSuccessMessage, ToastSeverity.SUCCESS);
  } catch (error) {
    gridComponent.controller.setLoadingState(false);
    GzToastNotificationWebComponent.closeAllToasts();
    showWatchlistActionToast(toastFailMessage, ToastSeverity.ERROR);

    if (specificSideMenu) {
      specificSideMenu.changeWatchlistButtonState(false);
    }

    return;
  }

  sideMenu.closeSideMenu();
  await gridComponent.controller.handleGridItemsLoad(true, true);
}

export function showWatchlistActionToast(message, severity) {
  const toastConfig: GzToast = {
    message: message,
    severity: severity,
    autoCloseDelayMs: 10000,
  };

  GzToastNotificationWebComponent.buildToastWrapperElement(toastConfig);
}

export function getWatchlistButtonTextBasedOnState(watchlistState) {
  return watchlistState === Watchlist.YES ? translateFn('Remove from watchlist') : translateFn('Add to watchlist');
}

export function buildPatchManagementInformation(applicationId, patchDataResponse, isCompanionStandalone: boolean) {
  const patchManagementInformation = {
    isCompanionStandalone,
  };

  if (patchDataResponse) {
    patchManagementInformation['hasPatchManagement'] = patchDataResponse.hasPatchManagement;
    patchManagementInformation['hasPatchesForApp'] = patchDataResponse.hasPatchesForApp;
    patchManagementInformation['hasPatchableEndpoints'] = patchDataResponse.hasPatchableEndpoints;
  }

  if (patchDataResponse && patchDataResponse['hasPatchesForApp'] === true) {
    patchManagementInformation['patchesCount'] = patchDataResponse.patch.patchesCount;
    patchManagementInformation['patchProductId'] = patchDataResponse.patch.patchProductId;
    patchManagementInformation['patchProductName'] = patchDataResponse.patch.patchProductName;
    patchManagementInformation['patchName'] = patchDataResponse.patch.patchName;
    patchManagementInformation['applicationIdToPatchIdMapping'] = {
      [applicationId]: patchDataResponse.patch.patchId,
    };
  }

  if (patchDataResponse && patchDataResponse['hasPatchableEndpoints'] === true) {
    patchManagementInformation['totalEndpoints'] = patchDataResponse.patch.totalEndpoints;
    patchManagementInformation['patchableEndpoints'] = patchDataResponse.patch.patchableEndpoints;
  }

  return patchManagementInformation;
}

export function isPatchManagementDetailsVisible(patchManagementDetails) {
  return patchManagementDetails && !patchManagementDetails['isCompanionStandalone'];
}

export function getPatchButtonDetails(patchManagementDetails) {
  if (!patchManagementDetails.hasPatchManagement) {
    return {
      patchButtonDisabled: true,
      patchButtonTooltiptext: translateFn('You require a license that includes the Patch Management feature.'),
    };
  }

  if (!patchManagementDetails.hasPatchableEndpoints) {
    return {
      patchButtonDisabled: true,
      patchButtonTooltiptext: translateFn(
        'Install the Patch Management module on affected endpoints before applying any app patches.',
      ),
    };
  }

  if (!patchManagementDetails.hasPatchesForApp) {
    return {
      patchButtonDisabled: true,
      patchButtonTooltiptext: translateFn('No patches available.'),
    };
  }

  return {
    patchButtonDisabled: false,
    patchButtonTooltiptext: '',
  };
}

export function addIgnoreAction(rowData, options) {
  if (rowData.item.state === State.IGNORED) {
    options.push({
      title: translateFn('Restore ignored resource'),
      value: ActionsColumnValues.RESTORE,
      event: {
        name: RiskManagementSideMenuEvents.RESTORE_DEVICES,
        detail: {
          companyId: rowData.item.company._id,
          endpointsIds: [rowData.item.endpointId],
        },
      },
    });
  } else {
    options.push({
      title: translateFn('Ignore resource'),
      value: ActionsColumnValues.IGNORE,
      event: {
        name: RiskManagementSideMenuEvents.IGNORE_DEVICES,
        detail: {
          companyId: rowData.item.company._id,
          endpointsIds: [rowData.item.endpointId],
        },
      },
    });
  }
}

function setScanButtonLoadingState(view, isLoading: boolean) {
  view.dom.scanButton.$button.setLoadingState(isLoading);
  view.dom.$scanEmptyStateButton.setLoadingState(isLoading);
  // we need to change the button type while loading for the spinner to be visible
  view.dom.scanButton.$button.type = isLoading ? ButtonTypes.OUTLINE : ButtonTypes.QUIET;
}

export function updateGridEmptyState(view) {
  const summaryExtraDetailsForGridView = view.dom.$grid.controller.getSummaryExtraDetailsForView();
  view.dom.scanButton.$button.disabled = !summaryExtraDetailsForGridView['company']['iorUsable'];
  view.dom.scanButton.$tooltip.tooltipText = summaryExtraDetailsForGridView['company']['iorUsable']
    ? ''
    : translateFn('Your current license does not provide access to this feature.');

  if (
    summaryExtraDetailsForGridView &&
    summaryExtraDetailsForGridView.hasOwnProperty('disableIorUserMonitoring') &&
    summaryExtraDetailsForGridView['disableIorUserMonitoring']
  ) {
    view.dom.$grid.controller.updateNoResultsMessage(translateFn('Feature unavailable'));

    view.dom.$riskManagementAdditionalText.innerHTML = `${translateFn(
      'You need to {OPEN_LINK} enable Identity monitoring {CLOSE_LINK} to start scanning for risks.',
      {
        OPEN_LINK: `<gz-link id="userMonitorLinkId">`,
        CLOSE_LINK: '</gz-link>',
      },
    )}`;

    const gzLink = view.dom.$riskManagementAdditionalText.querySelector('#userMonitorLinkId') as GzLinkWebComponent;
    if (gzLink) {
      gzLink.addEventListener('click', () => {
        handleEnableMonitoring({
          id: summaryExtraDetailsForGridView['company']['id'],
          name: summaryExtraDetailsForGridView['company']['name'],
        });
      });
    }

    elementClassListAdd(view.dom.$scanEmptyStateButton, ElementClass.HIDDEN);
  } else {
    view.dom.$grid.controller.updateNoResultsMessage(translateFn('Start scan to find risks'));
    view.dom.$riskManagementAdditionalText.innerText = translateFn('No risks identified.');
    elementClassListRemove(view.dom.$scanEmptyStateButton, ElementClass.HIDDEN);
    view.dom.$scanEmptyStateButton.innerText = translateFn('Scan');

    view.dom.$scanEmptyStateButton.disabled = !summaryExtraDetailsForGridView['company']['iorUsable'];
    view.dom.$scanEmptyStateTooltip.tooltipText = summaryExtraDetailsForGridView['company']['iorUsable']
      ? ''
      : translateFn('Your current license does not provide access to this feature.');
  }
}

export function handleEnableMonitoring(company) {
  NavigationHelper.navigateTo('/risk-management', { companyId: company.id });
}

export function calculateChangeStateBulkSelectAvailability(
  changeStateBulk: { $select: { disabled: boolean; options: any }; $tooltip: { tooltipText: any } },
  selectedGridItems: any[],
) {
  if (selectedGridItems.length > 0 && !selectedGridItems[0]['company']['specifics']['features']['iorUsable']) {
    changeStateBulk.$select.disabled = true;
    changeStateBulk.$tooltip.tooltipText = translateFn('Your current license does not provide access to this feature.');
    return;
  }

  changeStateBulk.$select.disabled = selectedGridItems.length === 0;
  changeStateBulk.$tooltip.tooltipText = '';
  const changeStateBulkSelectOptions = changeStateBulk.$select.options;
  const ignoreOption = changeStateBulkSelectOptions.find(option => option.value === ChangeStateBulkValues.IGNORE);
  ignoreOption.disabled = selectedGridItems.every(item => item.state === State.IGNORED);
  const restoreOption = changeStateBulkSelectOptions.find(option => option.value === ChangeStateBulkValues.RESTORE);
  restoreOption.disabled = selectedGridItems.every(item => item.state === State.ACTIVE);
}

export function calculateChangeWatchlistBulkSelectAvailability(
  changeWatchlistBulk: { $select: { disabled: boolean; options: any } },
  selectedGridItems: any[],
) {
  changeWatchlistBulk.$select.disabled = selectedGridItems.length === 0;
  const changeWatchlistBulkOptions = changeWatchlistBulk.$select.options;

  const addToWatchlistOption = changeWatchlistBulkOptions.find(
    option => option.value === ChangeWatchlistBulkValues.ADD_TO_WATCHLIST,
  );
  addToWatchlistOption.disabled = selectedGridItems.every(item => item.watchlist === Watchlist.YES);

  const removeFromWatchlistOption = changeWatchlistBulkOptions.find(
    option => option.value === ChangeWatchlistBulkValues.REMOVE_FROM_WATCHLIST,
  );
  removeFromWatchlistOption.disabled = selectedGridItems.every(item => item.watchlist === Watchlist.NO);
}

export function handleChangeStateBulkSelectionChanged(event: CustomEvent, fieldToSelect = '_id') {
  const newState = event.detail.selected;

  if (this.selectedItems.length === 0) {
    return;
  }

  const { companyId } = this.selectedItems[0];
  const ids = this.selectedItems.map(item => item[fieldToSelect]);

  switch (newState) {
    case ChangeStateBulkValues.IGNORE:
      this.createIgnoreDialog(ids, companyId);
      break;
    case ChangeStateBulkValues.RESTORE:
      this.createRestoreDialog(ids, companyId);
      break;
    default:
      break;
  }
}

export async function handleChangeWatchlistBulkSelectionChanged(event: CustomEvent) {
  if (this.selectedItems.length === 0) {
    return;
  }

  const selectedOption = event.detail.selected;
  let newWatchlist: Watchlist;
  switch (selectedOption) {
    case ChangeWatchlistBulkValues.ADD_TO_WATCHLIST:
      newWatchlist = Watchlist.YES;
      break;
    case ChangeWatchlistBulkValues.REMOVE_FROM_WATCHLIST:
      newWatchlist = Watchlist.NO;
      break;
    default:
      return;
  }

  const { companyId } = this.selectedItems[0];
  const ids = this.selectedItems.map(item => item._id);

  await this.updateWatchlistStatus(newWatchlist, ids, companyId);
}

export function handleSelectionChange(event: CustomEvent) {
  this.selectedItems = event.detail.selectionStoreData;
  calculateChangeStateBulkSelectAvailability(this.view.dom.changeStateBulk, this.selectedItems);
  calculateChangeWatchlistBulkSelectAvailability(this.view.dom.changeWatchlistBulk, this.selectedItems);
}

export function setBulkActions(stateTexts: { ignore: string; restore: string }) {
  this.dom.$header = this.shadow.querySelector('[slot=grid-header-actions-slot]');

  this.dom.changeStateBulk = {
    $select: this.shadow.querySelector('#change-state-bulk-select'),
    $text: this.shadow.querySelector('#change-state-bulk-button-text'),
    $tooltip: this.shadow.querySelector('#change-state-bulk-select-tooltip'),
  };
  this.dom.changeStateBulk.$select.options = [
    {
      title: stateTexts.ignore,
      value: ChangeStateBulkValues.IGNORE,
    },
    {
      title: stateTexts.restore,
      value: ChangeStateBulkValues.RESTORE,
    },
  ];
  this.dom.changeStateBulk.$text.innerText = translateFn('State');

  this.dom.changeWatchlistBulk = {
    $select: this.shadow.querySelector('#change-watchlist-bulk-select'),
    $text: this.shadow.querySelector('#change-watchlist-bulk-button-text'),
  };
  this.dom.changeWatchlistBulk.$select.options = [
    {
      title: translateFn('Add to watchlist'),
      value: ChangeWatchlistBulkValues.ADD_TO_WATCHLIST,
    },
    {
      title: translateFn('Remove from watchlist'),
      value: ChangeWatchlistBulkValues.REMOVE_FROM_WATCHLIST,
    },
  ];
  this.dom.changeWatchlistBulk.$text.innerText = translateFn('Watchlist');

  this.dom.scanButton = {
    $button: this.shadow.querySelector('#scan-button'),
    $tooltip: this.shadow.querySelector('#scan-button-tooltip'),
  };
  this.dom.scanButton.$button.innerText = translateFn('Scan');
}

export function setTranslatedStrings() {
  this.commonStrings = this.stringsTranslator.getCommonStrings();
  this.dom.$loadingErrorMessage.innerHTML = this.commonStrings.generalSystemError;

  const smartViewsTranslatedStrings = this.stringsTranslator.getSmartViewsTranslations();
  this.dom.$smartViewsTitle.innerHTML = smartViewsTranslatedStrings.genericPanelTitle.toUpperCase();

  this.dom.$riskManagementAdditionalText.innerText = translateFn('No risks identified.');
  this.dom.$scanEmptyStateButton.innerText = translateFn('Scan');
}

export async function handleScan(event: CustomEvent) {
  // set button state on loading until the request is resolved
  setScanButtonLoadingState(this.view, true);

  const summaryExtraDetailsForGridView = this.view.dom.$grid.controller.getSummaryExtraDetailsForView();
  const companyId = summaryExtraDetailsForGridView['company']['id'];

  let taskStatus: {
    nsvaAvailable: boolean;
    cspmAvailable: boolean;
    inProgress: boolean;
  } | null = null;
  let taskInProgressMessage = '';
  try {
    taskStatus = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'RiskManagementDevices',
      method: 'getRiskScanTaskStatus',
      payload: {
        companyId: companyId,
      },
    });
  } catch (error) {
    setScanButtonLoadingState(this.view, false);
  }

  setScanButtonLoadingState(this.view, false);

  if (taskStatus?.inProgress) {
    taskInProgressMessage = translateFn('The company has at least one scan task pending or in progress.');
  }

  const requestPayload: RiskScanParams = {
    parameters: {
      actionType: Actions.SCAN,
      companyId: companyId,
      scanEndpoints: true,
      scanCloud: taskStatus?.cspmAvailable ?? false,
      scanNSVA: taskStatus?.nsvaAvailable ?? false,
    },
  };

  const dialogBodyMessage = document.createElement('div');
  const textDiv = document.createElement('div');
  textDiv.innerHTML = `
    ${renderDialogText(
    translateFn(
      'All available resources and identities will be scanned and checked for security risks. These may include endpoints, users, configured networks and cloud resources. Results will be used to update Risk Management records.'),
  )}
      ${renderDialogText(taskInProgressMessage)}
  `;
  dialogBodyMessage.appendChild(textDiv);

  // Risk scan options, handling options change and validation
  let confirmButtonTarget: GzButtonWebComponent | undefined;
  dialogBodyMessage.appendChild(
    renderRiskScanOptions(taskStatus?.cspmAvailable ?? false, taskStatus?.nsvaAvailable ?? false, ev => {
      requestPayload.parameters[ev.detail.value] = ev.detail.checked;

      // Disable the confirm button if all options are unchecked
      if (confirmButtonTarget) {
        const scanTypes = ['scanCloud', 'scanEndpoints', 'scanNSVA'];
        confirmButtonTarget.disabled = scanTypes.every(type => !requestPayload.parameters[type]);
      }
    }),
  );

  const dialogConfig = {
    dialogTitle: translateFn('Start risk scan?'),
    confirmButtonText: translateFn('Scan'),
    dialogBodyMessage,
  };

  const { confirmButton } = createActionDialog(
    dialogConfig,
    {
      grid: this.view.dom.$grid,
      sideMenu: this.view.dom.$sideMenu,
    },
    requestPayload,
    {
      success: translateFn('The Risk scan task has been successfully created.'),
      error: translateFn('Failed to create risk scan task.'),
    },
    true,
    true,
  );
  confirmButtonTarget = confirmButton;
}

export function handleRowsLoadingFinishedEvent() {
  updateGridEmptyState(this.view);

  if (this.component.openSideMenuForFirstItem) {
    this.view.dom.$grid.controller.clickOnGridRow(0);
    this.component.openSideMenuForFirstItem = false;
  }
}

export function handleInlineMenuSelectionChangedExtraDetailsPanel(
  extraDetailsSidePanel: DeviceExtraDetailsWebComponent | UserExtraDetailsWebComponent,
  selectedOption: InlineMenuExtraDetailsSelectEvents,
  item,
  hasDetails: boolean,
  event,
) {
  switch (selectedOption) {
    case InlineMenuExtraDetailsSelectEvents.copyToClipboard:
      const [itemId] = Object.keys(item);

      copyToClipboard(hasDetails ? JSON.stringify(item) : itemId);
      handleTooltip(extraDetailsSidePanel, event);
      break;
    case InlineMenuExtraDetailsSelectEvents.viewIncidents:
      extraDetailsSidePanel.dispatchEvent(
        new CustomEvent(InlineMenuExtraDetailsSelectEvents.viewIncidents, {
          detail: {
            companyId: extraDetailsSidePanel.initialDropdownDetails?.companyId ?? extraDetailsSidePanel.companyId,
            item: item,
            itemsType: extraDetailsSidePanel.itemsType,
          },
          bubbles: true,
          cancelable: true,
          composed: true,
        }),
      );
      break;
    case InlineMenuExtraDetailsSelectEvents.viewEvents:
      extraDetailsSidePanel.dispatchEvent(
        new CustomEvent(InlineMenuExtraDetailsSelectEvents.viewEvents, {
          detail: {
            companyId: extraDetailsSidePanel.initialDropdownDetails?.companyId ?? extraDetailsSidePanel.companyId,
            item: item,
            itemsType: extraDetailsSidePanel.itemsType,
          },
          bubbles: true,
          cancelable: true,
          composed: true,
        }),
      );
      break;
  }
}

export function handleTooltip(extraDetailsSidePanel, event) {
  const clientRectDetails = event.currentTarget.getBoundingClientRect();

  GzTooltip.show(translateFn('Copied'), {
    clientX: clientRectDetails.x,
    clientY: clientRectDetails.y,
  } as MouseEvent);

  extraDetailsSidePanel.tooltipShown = setTimeout(() => {
    GzTooltip.hide();
  }, 2000);
}

export function handlePivotFromExtraDetailsPanelToIncidents(event: CustomEvent) {
  switch (event.detail.itemsType) {
    case FindingsDetailsItemsType.PATHS:
      Application.lib.Navigation.openInNewTab(
        `/incidents/filter/filepath/${event.detail.companyId}&${encodeURIComponent(Object.keys(event.detail.item)[0])}`,
      );
      break;
    case FindingsDetailsItemsType.REGISTRIES:
      Application.lib.Navigation.openInNewTab(
        `/incidents/filter/registry/${event.detail.companyId}&${encodeURIComponent(Object.keys(event.detail.item)[0])}`,
      );
      break;
    case FindingsDetailsItemsType.HOSTS:
      Application.lib.Navigation.openInNewTab(
        `/incidents/filter/url/${event.detail.companyId}&${encodeURIComponent(Object.keys(event.detail.item)[0])}`,
      );
      break;
    case FindingsDetailsItemsType.SHARED_PASSWORDS:
      Application.lib.Navigation.openInNewTab(
        `/incidents/filter/url/${event.detail.companyId}&${encodeURIComponent(Object.keys(event.detail.item)[0])}`,
      );
      break;
    case FindingsDetailsItemsType.DETECTIONS:
      Application.lib.Navigation.openInNewTab(
        `/incidents/filter/alertname/${event.detail.companyId}&${encodeURIComponent(Object.keys(event.detail.item)[0])}`,
      );
      break;
    default:
      console.warn('Item type not found.');
  }
}

export function handlePivotFromExtraDetailsPanelToAdvancedSearch(event: CustomEvent) {
  switch (event.detail.itemsType) {
    case FindingsDetailsItemsType.PATHS:
      Application.lib.Navigation.openInNewTab(
        `/xdr/events/path/${event.detail.companyId}&${encodeURIComponent(Object.keys(event.detail.item)[0])}`,
      );
      break;
    case FindingsDetailsItemsType.REGISTRIES:
      Application.lib.Navigation.openInNewTab(
        `/xdr/events/registry/${event.detail.companyId}&${encodeURIComponent(Object.keys(event.detail.item)[0])}`,
      );
      break;
    case FindingsDetailsItemsType.HOSTS:
      Application.lib.Navigation.openInNewTab(
        `/xdr/events/host/${event.detail.companyId}&${encodeURIComponent(Object.keys(event.detail.item)[0])}`,
      );
      break;
    case FindingsDetailsItemsType.SHARED_PASSWORDS:
      Application.lib.Navigation.openInNewTab(
        `/xdr/events/uri/${event.detail.companyId}&${encodeURIComponent(Object.keys(event.detail.item)[0])}`,
      );
      break;
    case FindingsDetailsItemsType.DETECTIONS:
      Application.lib.Navigation.openInNewTab(
        `/xdr/events/alertname/${event.detail.companyId}&${encodeURIComponent(Object.keys(event.detail.item)[0])}`,
      );
      break;
    default:
      console.warn('Item type not found.');
  }
}

export function setComplianceDisclaimer(disclaimer) {
  // If company is partner disclaimer message should not appear
  if (!Application.Main.company.isCustomer()) {
    disclaimer.$box.hidden = true;
  } else {
    disclaimer.$text.innerText = translateFn(
      "The Compliance-related information is currently available as a new feature of Risk Analytics, provided 'AS IS'. Future changes may apply.",
    );
  }
}

export function overlayOpenListener() {
  if (document.body.style.pointerEvents === 'none') {
    document.body.style.pointerEvents = 'auto';
  }
}

export function isCloudResource(type) {
  const endpointResources = [DEVICES_TYPE.ENDPOINT, DEVICES_TYPE.SERVER];

  return !endpointResources.includes(type);
}

export function isCloudPlatform(type: number) {
  return AllCloudProviders.includes(type);
}

export function processAffectedDeviceData(typeToItemsMapping): Array<CategoriesItems> {
  const categories: Array<CategoriesItems> = [];
  for (const resourceTypeFromOrder of DEVICES_TYPES_ORDER) {
    if (!typeToItemsMapping[resourceTypeFromOrder]) {
      continue;
    }

    const categoryForSidePanel: CategoriesItems = {
      icon: DEVICES_CLASS.get(resourceTypeFromOrder),
      type: resourceTypeFromOrder,
      text: BaseWebComponentTranslator.getInstance().getDeviceTypes(resourceTypeFromOrder),
      items: typeToItemsMapping[resourceTypeFromOrder],
    };

    categories.push(categoryForSidePanel);
  }

  return categories;
}

export function processVulnerableIdentitiesData(typeToItemsMapping): Array<CategoriesItems> {
  const categories: Array<CategoriesItems> = [];
  for (const identityTypeFromOrder of USERS_TYPES_ORDER) {
    if (!typeToItemsMapping[identityTypeFromOrder]) {
      continue;
    }

    const categoryForSidePanel: CategoriesItems = {
      icon: USERS_ICON_CLASS_MAP.get(identityTypeFromOrder),
      type: identityTypeFromOrder,
      text: BaseWebComponentTranslator.getInstance().getRiskManagementUserType(identityTypeFromOrder),
      items: typeToItemsMapping[identityTypeFromOrder],
    };

    categories.push(categoryForSidePanel);
  }

  return categories;
}

/**
 *
 * @param companyId
 * @param {string} categoryToScroll
 * @param {string} title
 * @param {string} searchPlaceholder
 * @param {Array<ActionsDetails> | null} actionsDetails
 * @returns {CategoriesSideMenuWebComponent}
 */
export function buildCategoriesSideMenu(
  companyId: string,
  categoryToScroll: string,
  title: string = '',
  searchPlaceholder: string = '',
  actionsDetails: null | Array<ActionsDetails> = null,
) {
  const categoriesSideMenu = new CategoriesSideMenuWebComponent();
  categoriesSideMenu.title = title === '' ? translateFn('Affected resources') : title;
  categoriesSideMenu.companyId = companyId;
  categoriesSideMenu.searchCategoriesPlaceholder =
    searchPlaceholder === '' ? translateFn('Search resources') : searchPlaceholder;
  categoriesSideMenu.categoryToScroll = categoryToScroll;

  if (actionsDetails) {
    categoriesSideMenu.actionsDetails = actionsDetails;
  } else {
    categoriesSideMenu.actionsDetails = [
      {
        title: translateFn('View resource'),
        value: DropdownActionsSelection.VIEW_RESOURCE,
        actionCallback: (categoryType, item, index, companyIdParam) => {
          Application.lib.Navigation.openAppPageInNewTab(`/risk-management-resources`, {
            filters: [
              {
                [DevicesColumnKeys.DEVICE_NAME]: {
                  complexEnumFilter: [
                    {
                      label: item.name,
                      value: item.id,
                    },
                  ],
                },
              },
              {
                [DevicesColumnKeys.COMPANY]: { exactMatch: companyIdParam },
              },
            ],
          });
        },
      },
      {
        title: translateFn('View incidents'),
        value: DropdownActionsSelection.VIEW_INCIDENTS,
        actionCallback: (categoryType, item, index, companyIdParam) => {
          Application.lib.Navigation.openInNewTab(`/incidents/filter/entity/${item.id}`);
        },
      },
    ];
  }

  return categoriesSideMenu;
}

// Hide Resources section on cloud-based misconfiguration types.
// subcategory is the backend field name for misconfiguration type.
export function hideResourcesOnMisconfigurationType(subcategory) {
  switch (subcategory) {
    case MisconfigurationType.CLOUD:
    case MisconfigurationType.ACCESS_CONTROL:
    case MisconfigurationType.CONTROL_PLANE:
    case MisconfigurationType.SECRETS:
    case MisconfigurationType.WORKLOAD:
      return true;
    default:
      return false;
  }
}
